import axios from "@/services/api/axios";

import {arrayHasObjBy} from "@/services/helper";

class HttpClient {
    constructor() {
        this.httpClient = axios;
        const baseUrl = document.getElementById('rest_url').textContent;

        if (!baseUrl) {
            throw new Error('No baseurl found. Must be used on at least Mounted state');
        }

        this.setBaseURL(baseUrl);
    }

    setBaseURL(baseUrl) {
        this.httpClient.defaults.baseURL = baseUrl;
    }

    async getListingItems(postType, params) {
        return await this.httpClient.get(postType, {params: params});
    }

    async getVenue(postId) {
        return await this.httpClient.get('tribe/events/v1/venues/' + postId);
    }

    async getCurrentFilters(searchResults) {
        const markerTypes = await this.httpClient.get('wp/v2/marker_type?per_page=999');

        const markers = searchResults.map((item) => {
            if (markerTypes.some(mItem => mItem.id === item.marker_type[0])) {
                return {type: item.type, ...markerTypes.find(mItem => mItem.id === item.marker_type[0])};
            }
        }).filter(Boolean);

        return markers.reduce((result, obj) => {
            const type = obj.type;
            const name = obj.name;

            if (!result.hasOwnProperty(type)) {
                result[type] = [];
            }

            if (!arrayHasObjBy(result[type], 'name', name)) {
                const filterObj = {id: obj.id, name: obj.name, count: 0}

                for (const searchResult of searchResults) {
                    if (searchResult.marker_type.includes(obj.id)) {
                        filterObj.count++
                    }
                }

                result[type].push(filterObj);
            }

            return result;
        }, {});
    }
}

export default new HttpClient();
